import { BookMarked, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function MemoirStrip() {
  return (
    <section data-testid="memoir-strip" className="relative border-t-2 border-ink bg-royal py-10 sm:py-12">
      <div className="halftone-light absolute inset-0" aria-hidden="true" />
      <Reveal className="relative mx-auto flex max-w-7xl flex-col items-center gap-5 px-4 text-center sm:px-6 md:flex-row md:justify-between md:text-left">
        <div className="flex items-center gap-4">
          <span className="hidden h-12 w-12 shrink-0 items-center justify-center rounded-xl border-2 border-banana/60 bg-banana/15 sm:flex">
            <BookMarked className="h-6 w-6 text-banana" />
          </span>
          <div>
            <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-banana">Grown-ups, this one's for you</p>
            <p className="mt-1.5 font-display text-lg font-semibold leading-snug text-cream sm:text-xl">
              From the author of{" "}
              <span className="text-banana">Corella, The Author of My Own Story</span> — a memoir about holding the pen
              and writing your own ending.
            </p>
          </div>
        </div>
        <a
          data-testid="memoir-amazon-link"
          href="https://www.amazon.com/Corella-Author-My-Own-Story-ebook/dp/B0FLWVC7YB"
          target="_blank"
          rel="noopener noreferrer"
          className="group flex shrink-0 items-center gap-2 rounded-full border-2 border-banana px-6 py-3 font-head text-sm font-extrabold uppercase tracking-wide text-banana transition-all duration-200 hover:-translate-y-0.5 hover:bg-banana hover:text-ink"
        >
          Find the memoir
          <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </Reveal>
    </section>
  );
}
